import { IconButton } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import CloseIcon from "./icons/CloseIcon";

export default function CloseModalButton({ type = "default", handleToggle }) {
  const style = {
    zIndex: "1000",
    position: "absolute",
    top: "0",
    right: "0",
    transform:
      type === "point-details"
        ? "translate(-0.5rem, 0.5rem)"
        : "translate(0.5rem, -0.5rem)",
    backgroundColor:
      type === "point-details" ? "rgba(0, 0, 0, 0.80)" : "transparent",
    "&:hover": {
      backgroundColor:
        type === "point-details" ? "rgba(0, 0, 0, 0.25)" : "transparent",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1rem",
      "& path": {
        fill: type === "point-details" ? "#fff" : "#000",
      },
    },
  };
  return (
    <IconButton
      size="large"
      aria-label="Schließen"
      onClick={handleToggle}
      sx={style}
    >
      <SvgIcon>
        <CloseIcon />
      </SvgIcon>
    </IconButton>
  );
}
